import chroma from 'chroma-js';
import { BLACK, WHITE } from 'src/constants/ui';

export const isLightColor = ([r, g, b]: [number, number, number]) => {
  // Counting the perceptive luminance
  // human eye favors green color...
  const a = 1 - (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return a < 0.5;
};

export const getTextColor = (bgColor: any): string => {
  if (chroma.valid(bgColor)) {
    return isLightColor(chroma(bgColor).rgb()) ? BLACK : WHITE;
  }
  return BLACK;
};

export const getColorSwatch = (baseColor: any) => {
  const colorChroma = chroma.valid(baseColor) ? chroma(baseColor) : chroma('#000000');

  // Preserve the exact user input as the 500 level (main color)
  const userColor = colorChroma.hex();

  // Generate lighter shades (50, 100, 200, 300, 400)
  // Use luminance mixing for more natural light tints
  const lighterShades = {
    50: chroma.mix(colorChroma, '#ffffff', 0.9).hex(),
    100: chroma.mix(colorChroma, '#ffffff', 0.8).hex(),
    200: chroma.mix(colorChroma, '#ffffff', 0.6).hex(),
    300: chroma.mix(colorChroma, '#ffffff', 0.4).hex(),
    400: chroma.mix(colorChroma, '#ffffff', 0.2).hex(),
  };

  // Generate darker shades (600, 700, 800, 900)
  // Use smaller increments for more natural progression
  const darkerShades = {
    600: colorChroma.darken(0.5).hex(),
    700: colorChroma.darken(1).hex(),
    800: colorChroma.darken(1.5).hex(),
    900: colorChroma.darken(2).hex(),
  };

  return {
    ...lighterShades,
    500: userColor, // Preserve the exact user input
    ...darkerShades,
  };
};
